/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespShopByModule_homepage$ref: FragmentReference;
export type HpRespShopByModule_homepage = {|
  +shopByModule: ?{|
    +title?: ?string,
    +location?: ?{|
      +title: ?string,
      +imageUrl: ?string,
      +items: ?$ReadOnlyArray<?{|
        +cmsId: ?number,
        +title: ?string,
        +link: ?string,
      |}>,
    |},
    +items?: ?$ReadOnlyArray<?{|
      +cmsId: ?number,
      +title: ?string,
      +link: ?string,
      +imageUrl: ?string,
    |}>,
  |},
  +$refType: HpRespShopByModule_homepage$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cmsId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespShopByModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "shopByModule",
      "name": "module",
      "storageKey": "module(type:\"shopBy\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "shopBy",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "ShopByModule",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "location",
              "storageKey": null,
              "args": null,
              "concreteType": "Location",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "items",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LocationItem",
                  "plural": true,
                  "selections": [
                    (v2/*: any*/),
                    (v0/*: any*/),
                    (v3/*: any*/)
                  ]
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "Product",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v0/*: any*/),
                (v3/*: any*/),
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '94246581f6326e8c4164128ee017df2e';
module.exports = node;
